module.exports = __webpack_public_path__ + "ENG_SPT10-Soccer_225003020-fbd50159d432b9a19ca93495a251c7ff.png";